// ===========================================================
// DATOS DE LA EMPRESA
// Estos datos se usan en el header del PDF imprimible.
// Editá los valores aquí cuando quieras cambiarlos.
// ===========================================================

export const COMPANY = {
  // Nombre comercial (lo que se muestra en grande)
  name: 'Tiziano Caffè Gelato',

  // Razón social legal
  legalName: 'Tiziano Leipzig GmbH & Co.KG',

  // Dirección
  street: 'Paunsdorfer Allee 1',
  postalCode: '04329',
  city: 'Leipzig',
  country: 'Deutschland',

  // Contacto (completá con tus datos reales)
  phone: '',
  email: '',
  website: '',

  // Datos fiscales
  taxNumber: '232/166/49702',  // Steuer-Nr de la factura
  vatId: '',                    // USt-IdNr (si tenés)

  // Logo (path relativo al servidor)
  logoUrl: '/logo.png',
} as const;
